import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class TextStyleOption extends BaseOption {
  static userInterfaceComponent = () => {
    return {
      label: "Style",
      component: inspectorTools.SIMPLE_PICKER,
      canSetAsVariable: false,
      props: {
        // No sideEffect: same reasoning as `text-branding-style-option`
        // — picking a style writes the value here and
        // `TypographyBranding.determineType` routes the chain lookup
        // to the matching BrandedXxxElement row at read time. The
        // element keeps its identity across style flips so per-
        // instance overrides survive.
        options: [
          {
            id: "heading",
            name: "Heading",
          },
          {
            id: "subheading",
            name: "SubHeading",
          },
          {
            id: "title",
            name: "Title",
          },
          {
            id: "label",
            name: "Label",
          },
          {
            id: "paragraph",
            name: "Paragraph",
          },
          {
            id: "note",
            name: "Note",
          },
        ],
      },
    };
  };

  static defaultValue = "heading";

  static VariantOptions = {
    "heading": "BrandedHeadingElement",
    "subheading": "BrandedSubHeadingElement",
    "title": "BrandedTitleElement",
    "label": "BrandedLabelElement",
    "paragraph": "BrandedParagraphElement",
    "note": "BrandedNoteElement",
  };
}
